import { EntDirectoryInfoName } from '../directoryInfoName'

export class EntTypesOfFertilizers {
	id: number | null = null
	nameKy: string | null = null
	nameRu: string | null = null
	fertilizerCategory?: EntDirectoryInfoName | null = null
	fertilizerCategoryId?: number | null = null
}

export class EntTypesOfCompany {
	companyName: string | null = null
	id: number | null = null
}
